<ng-container *ngIf="pillar">
  <form [formGroup]="pillarForm" class="">
    <div class="wrapperForm">
      <div *ngIf="pillarName === 'nature'">
      <div class="message-container">
        <div> <img class="nat-img" src="assets\images\report\pillarImages\nature_leaf.png" alt=""/></div>
        <div class="pillar-info-wrap">=</div>
        <div class="text-container">{{'GIGATON_NATURE_PILLAR_GREEN_LEAVES_INFO' | translate}}</div>
      </div>
    </div>
      <div class="qus-divider"  *ngFor="let activity of pillar.activities; index as activityIndex">
        <div class="qus-sub-heading" [ngClass]="(activity.category && activityIndex !=0)?'contentWrapper':''">{{activity.category?activity.category:""}}</div>

        <mat-error *ngIf="activity.hasDependency">
          {{activityDependency.checkHasAllowToAnswer(activity,(pillarForm.get('activitiesFormGroup')['controls'][activityIndex]).get('toggleFlagCtl'))}}

        </mat-error>
          <div class="mainOuter">
            <div class="questionWrapper" [ngClass]="{'nat-img-wrap': pillarName === 'nature' && !activity.hasNatureLandOceanSavings}">
              <span *ngIf="pillarName === 'nature' && activity.hasNatureLandOceanSavings">
                <span class="pkg-format-tooltip-wrap">
                  <mat-icon matTooltipClass="pkg-mat-tooltip" [matTooltip]="'GIGATON_NATURE_PILLAR_GREEN_LEAVES_INFO'| translate"  matTooltipPosition="right">
                    <img class="nat-img" src="assets\images\report\pillarImages\nature_leaf.png" alt=""/> </mat-icon>
                  </span>    
              </span>
              <span class="slnumbr">{{activity.slno}}</span>
              <div>
                <span class="calc-qus">{{activity.text}}</span>
                <span> <em class="material-icons help-icon-cals pos_adjust" *ngIf="activity.tooltip" (click)="showTooltipPopUp(activity)">help_outline</em></span>


              </div>
            </div>
            <app-toggle [activity]="activity" [activityIndex]="activityIndex" [pillarName]="pillarName" [toggleFlagCtl]="(pillarForm.get('activitiesFormGroup')['controls'][activityIndex]).get('toggleFlagCtl')"></app-toggle>
          </div>

          <mat-error *ngIf="activity['duplicateEntryFlag']">{{'DuplicateEntry' | translate}}</mat-error>
          <ng-container *ngTemplateOutlet="errorwarning; context:{ msg: 'DuplicateEntryField4', attr: 'DuplicateEntryField4'}"></ng-container>
          <ng-container *ngTemplateOutlet="errorwarning; context:{ msg: 'DuplicateEntryField3', attr: 'DuplicateEntryField3'}"></ng-container>
          <ng-template #errorwarning let-msg="msg" let-attr="attr">
            <mat-error *ngIf="activity[attr] && !activity['duplicateWarningOnly']">{{msg | translate}}</mat-error>
            <div *ngIf="activity[attr] && activity['duplicateWarningOnly']" class="gigaton-warning">{{msg | translate}}</div>
          </ng-template>
          <div *ngIf="activity.toggleFlag">
            <ng-container *ngIf="(activity['qusType'] && activity['qusType']=== 'table'); else normalActivity">
              <app-waste-reduction *ngIf="wasteRedService.getTableConfigQus(activity.id)"
                [activity]="activity" [reportSubmissionId]="reportSubmissionId" [activityForm]="pillarForm.get('activitiesFormGroup')['controls'][activityIndex]"
                (errorInWasteComp)="errorInActivity($event)"
                [wasteConfigJson]="wasteRedService.getTableConfigQus(activity.id)">
              </app-waste-reduction>
            </ng-container>

            <ng-template #normalActivity>
              <app-calc-activity [activity]="activity" [activityForm]="pillarForm.get('activitiesFormGroup')['controls'][activityIndex]"
                [pillarName]="pillar.name" (modifiedActivity)="onModified($event)" (errorInActivityCalcComp)="errorInActivity($event)"></app-calc-activity>
            </ng-template>
          </div>


    </div>
    </div>
    <div>
      <div class="cals-btn-sec">
        <div class="d-flex">
          <button type="button" mat-raised-button class="finish-report-btn" [disabled]="pillarName==='energy'" (click)="previousTab()"
          >{{'PreviousPillar'
            | translate }}</button>
          <button type="button" mat-raised-button class="finish-report-btn" [disabled]="pillarName==='others'" (click)="nextTab()"
          >{{'NextPillar'
            | translate }}</button>
        </div>
      </div>
    </div>
    <ng-container *ngIf="this.commActService.commPillarHasToReload[this.pillar.name]">
      {{updateCommonPillar()}}
    </ng-container>
  </form>
</ng-container>

<ng-template #messagePopupTemplate>
  <dialog-content *ngIf='dialogContentMetadata' [dialogContent]="dialogContentMetadata" (onConfirmation)="onMessageDialogClose($event)">
  </dialog-content>
</ng-template>

